import React, { useEffect } from 'react'
import { useQuery } from '@apollo/react-hooks'
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom'
import { examsPropertiesQueries } from '../graphql/queries'
import PDFButton from '../components/PDFButton'
import ExamFeedbackResult from './ExamFeedbackResult'
import Container from '@material-ui/core/Container'

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-end',
        '& > button' :{
            marginLeft: '28px',
        },
        '@media (max-width: 765px)': {
            padding: 0,
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            overflow: 'auto',
        },
        '@media (min-width: 766px) and (max-width: 1050px)': {
            padding: 0,
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            overflow: 'auto',
            marginLeft: '2.5%'
        },
    },
}))

const ExamFeedbackStructure = ({ results }) => {
    const { id } = useParams()
    const classes = useStyles();

    const { loading, error, data } = useQuery(examsPropertiesQueries.GET_EXAM_RESULT, {
        variables: {
            _id: id
        }
    })

    useEffect(() => {
        window.MathJax.typeset()
    })

    if (loading || error) {
        return null
    }

    return (
        <Container className={classes.root}>
            <PDFButton resultId={id || ''} />
            <ExamFeedbackResult data={data || {}}/>
        </Container>
    )
}

export default ExamFeedbackStructure 